(function () {
    var bfj = document.querySelector('.bfj');
    if (!bfj) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ----- zoom-in crossfade slideshow ----- */
    function startShot(shot) {
        if (shot.dataset.playing === '1') return;
        shot.dataset.playing = '1';
        var slides = Array.prototype.slice.call(shot.querySelectorAll('.bfj-shot__slide'));
        shot.classList.add('is-playing');
        var interval = parseInt(shot.dataset.interval, 10) || 0;
        if (slides.length < 2 || interval === 0 || reduce) return;
        var idx = 0;
        setInterval(function () {
            var cur = slides[idx];
            idx = (idx + 1) % slides.length;
            var nxt = slides[idx];
            // keep zoom animation running on outgoing slide until opacity transition ends
            cur.classList.add('is-leaving');
            cur.classList.remove('is-active');
            setTimeout(function () {
                cur.classList.remove('is-leaving');
            }, 1300);
            // restart zoom animation on the newly active slide
            nxt.style.animation = 'none';
            void nxt.offsetWidth;
            nxt.style.animation = '';
            nxt.classList.add('is-active');
        }, interval);
    }

    /* ----- slideshow trigger (cluster entry) ----- */
    var clusters = bfj.querySelectorAll('[data-cluster]');
    var cObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            e.target.querySelectorAll('[data-shot]').forEach(startShot);
            cObs.unobserve(e.target);
        });
    }, {threshold: 0.28});
    clusters.forEach(function (c) {
        cObs.observe(c);
    });

    /* ----- mask reveal (per shot entry) ----- */
    var shots = bfj.querySelectorAll('[data-shot]');
    var sObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            e.target.classList.add('is-revealed');
            sObs.unobserve(e.target);
        });
    }, {threshold: 0.2});
    shots.forEach(function (s) {
        sObs.observe(s);
    });

    /* ----- rise-in text ----- */
    var rObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
            if (e.isIntersecting) {
                e.target.classList.add('is-in');
                rObs.unobserve(e.target);
            }
        });
    }, {threshold: 0.18});
    bfj.querySelectorAll('.bfj-rise').forEach(function (el) {
        rObs.observe(el);
    });

    /* ----- parallax ----- */
    var px = Array.prototype.slice.call(bfj.querySelectorAll('[data-parallax]'));
    var ticking = false;

    function onScroll() {
        var vh = window.innerHeight;
        px.forEach(function (el) {
            var host = el.parentElement;
            var r = host.getBoundingClientRect();
            if (r.bottom < -200 || r.top > vh + 200) return;
            var speed = parseFloat(el.dataset.parallax) || 0.2;
            // progress: -1 (below) .. 1 (above), 0 when host centered
            var progress = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
            var shift = -progress * speed * r.height;
            el.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
        });
        ticking = false;
    }

    function req() {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(onScroll);
        }
    }

    if (!reduce) {
        window.addEventListener('scroll', req, {passive: true});
        window.addEventListener('resize', req);
        onScroll();
    }

    /* ----- easing scroll for nav cards ----- */
    function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function scrollTo(target, duration) {
        var start = window.scrollY;
        var end = target.getBoundingClientRect().top + start;
        var startTime = null;

        function step(now) {
            if (!startTime) startTime = now;
            var elapsed = now - startTime;
            var progress = Math.min(elapsed / duration, 1);
            window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
            if (progress < 1) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
    }

    bfj.querySelectorAll('.bfj-nav__card[href^="#"]').forEach(function (a) {
        a.addEventListener('click', function (e) {
            var target = document.querySelector(a.getAttribute('href'));
            if (!target) return;
            e.preventDefault();
            scrollTo(target, 900);
        });
    });
})();